<template>
  <div id="app">
    <b-alert
      :show="getAlert.show"
      dismissible
      :variant="getAlert.variant"
      @dismissed="dismissAlert(0)"
      @dismiss-count-down="countDownChanged"
    >
      <div class="container">
        <b-icon
          font-scale="1"
          v-if="getAlert.variant != 'success'"
          icon="exclamation-circle"
        ></b-icon>
        <b-icon font-scale="1" v-else icon="check-circle"></b-icon>
        {{ getAlert.message }}
        <div class="pull-right">
          <b-icon
            @click="dismissAlert()"
            font-scale="1.5"
            icon="x-circle"
            class=""
          ></b-icon>
        </div>
      </div>
      <b-progress
        :variant="getAlert.variant"
        :max="5"
        :value="getAlert.show"
        height="5px"
      ></b-progress>
    </b-alert>

    <header id="header">
      <div class="container">
        <img
          alt="Regenesis Logo"
          class="d-none d-md-block my-2"
          src="@/assets/logo.png"
        />
        <img
          alt="Regenesis Logo"
          class="d-sm-block d-md-none my-1"
          src="@/assets/logo.png"
        />
      </div>
    </header>

    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "steps-layout",
    data() {
      return {
        dismissCountDown: 5000,
      };
    },
    computed: {
      ...mapGetters({
        getAlert: "dashboard/getAlerts",
      }),
    },
    methods: {
      ...mapActions({}),
      tratar(item) {
        var date1 = new Date();
        var date2 = new Date(item);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
      },
      countDownChanged(dismissCountDown) {
        this.$store.commit("dashboard/SET_ALERT", {
          show: dismissCountDown,
          message: this.getAlert.message,
          variant: this.getAlert.variant,
        });
      },
      dismissAlert(value) {
        this.$store.commit("dashboard/SET_ALERT", {
          show: value,
          message: "",
          variant: "",
        });
      },
    },
  };
</script>

<style lang="scss">
  body {
    background: #f3f3f3;
  }

  .alert {
    position: fixed;
    width: 100%;
    border: none;
    border-radius: 0;
    z-index: 10;
  }

  #app {
    display: flex;
    height: fit-content;
    flex-direction: column;

    .alert + header#header {
      top: 73px;
    }
  }

  header#header {
    background: #fff;
    padding: 0.75rem;
    border-bottom: 1px solid #e9e9e9;
    position: fixed;
    width: 100%;
    z-index: 10;
  }
</style>
